import { cn } from '@/lib/utils'
import type { HTMLAttributes, ReactNode } from 'react'

type ChipVariant =
  | 'default'
  | 'navy'
  | 'amber'
  | 'emerald'
  | 'rose'
  | 'blue'
  | 'violet'
  | 'outline'

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant
  children: ReactNode
}

const styles: Record<ChipVariant, string> = {
  default: 'bg-slate-100 text-slate-700',
  navy: 'bg-navy-700 text-white',
  amber: 'bg-amber-50 text-amber-600',
  emerald: 'bg-emerald-50 text-emerald-700',
  rose: 'bg-rose-50 text-rose-700',
  blue: 'bg-blue-50 text-blue-700',
  violet: 'bg-violet-50 text-violet-700',
  outline: 'bg-transparent border border-slate-300 text-slate-600',
}

export function Chip({ variant = 'default', className, children, ...props }: ChipProps) {
  return (
    <span className={cn('chip', styles[variant], className)} {...props}>
      {children}
    </span>
  )
}
